import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Cookieless, no-PII page-view tracking. Fires once per route change to
 * /api/track. Skips internal admin/auth routes. Failures are swallowed so
 * analytics can never affect the site.
 */
const Analytics = () => {
  const location = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith('/admin') || path === '/login') return;
    if (lastPath.current === path) return; // guard StrictMode double-invoke
    lastPath.current = path;

    fetch('/api/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path, referrer: document.referrer || null }),
      keepalive: true,
    }).catch(() => {
      /* ignore */
    });
  }, [location.pathname]);

  return null;
};

export default Analytics;
